import { database } from './firebase';
import { ref, get, set, child } from 'firebase/database';

class CostsService {
    constructor() {
        this.cache = new Map(); // branch -> { productId -> costVal }
        this.lastFetch = new Map(); // branch -> timestamp
        this.CACHE_DURATION = 1000 * 60 * 5; // 5 minutes cache
    }

    /**
     * Fetch costs for a specific branch
     * Structure in RTDB: product_costs/{branchName}/{productId} = { cost: 10.50, updatedAt: ... }
     */
    async getCosts(branch, force = false) {
        if (!branch) throw new Error('Branch is required');

        // Normalize branch name for path key (simple sanitation)
        const branchKey = this._sanitizeKey(branch);

        const now = Date.now();
        if (!force && this.cache.has(branchKey) && this.lastFetch.has(branchKey)) {
            if (now - this.lastFetch.get(branchKey) < this.CACHE_DURATION) {
                return this.cache.get(branchKey);
            }
        }

        try {
            console.log(`[CostsService] Fetching costs for branch: ${branch}`);
            const costsRef = ref(database, `product_costs/${branchKey}`);
            const snapshot = await get(costsRef);

            if (snapshot.exists()) {
                const data = snapshot.val();
                this.cache.set(branchKey, data);
                this.lastFetch.set(branchKey, now);
                return data;
            } else {
                this.cache.set(branchKey, {});
                this.lastFetch.set(branchKey, now); // cachear también "sin costos" para no repetir la lectura
                return {};
            }
        } catch (error) {
            console.error('[CostsService] Error fetching costs:', error);
            throw error;
        }
    }

    /**
     * Update cost for a specific product
     */
    async updateCost(branch, productId, cost) {
        if (!branch || !productId) throw new Error('Invalid arguments');

        const branchKey = this._sanitizeKey(branch);
        const costRef = ref(database, `product_costs/${branchKey}/${productId}`);

        const payload = {
            cost: Number(cost),
            updatedAt: Date.now()
        };

        await set(costRef, payload);

        // Update cache locally
        const currentCache = this.cache.get(branchKey) || {};
        currentCache[productId] = payload;
        this.cache.set(branchKey, currentCache);

        return payload;
    }

    /* Helper to make branch names safe for RTDB keys */
    _sanitizeKey(key) {
        return key.replace(/[.#$/[\]]/g, '_');
    }
}

export const costsService = new CostsService();
